export default "__VITE_ASSET__Ul8gmLOT__"